import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import { polyfill } from 'mobile-drag-drop';
polyfill();
import { Drag, Drop } from 'vue-drag-drop';

Vue.config.productionTip = false;

Vue.component('drag', Drag);
Vue.component('drop', Drop);

new Vue({
    router,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
